<template>
	<el-table
		v-bind:data="appointmentType"
		:show-header="false"
		row-key="id"
		@row-click="expandRow"
		:expand-row-keys="expand"
		empty-text="No appointments scheduled yet"
		style="width: 100%">

		<!-- Expandable message history list -->
		<el-table-column type="expand">
			<template slot-scope="scope">
				<AppointmentSummary v-for="e in scope.row.event" :appointment="e">
				</AppointmentSummary>
			</template>
		</el-table-column>

		<el-table-column prop="title" width="500">
			<template slot-scope="scope">
				<div style="line-height:16px">
					<strong>
						{{ getContentKey('appointment', scope.row.id.split(':')[0], 'title') }}
						<span class="appointment-provider" v-if="allPatientsChosen">
							{{ getProviderNameById(scope.row.id.split(':')[1]) }} {{ getProfileFromProvider(scope.row.id.split(':')[1], patient)}}
						</span>
					</strong><br>
					<small>{{ scope.row.event.length }} scheduled</small>
				</div>
			</template>
		</el-table-column>

		<el-table-column prop="title" width="300">
			<template slot-scope="scope">
				<div style="line-height:16px" v-if="scope.row.active.length > 0">
					Scheduled for <strong>{{ scope.row.active.map((active) => formatDate(active.time)).join(', ') }}</strong>
				</div>
			</template>
		</el-table-column>

		<el-table-column fixed="right">
			<!-- <template slot-scope="scope">
				<div style="text-align:right">
					...
				</div>
			</template> -->
		</el-table-column>

	</el-table>
</template>
<script>
import CardTable from '../component/table'
import { mapState, mapGetters, mapActions } from 'vuex'

import AppointmentSummary from './Summary'

export default {
	name: 'patient-questionnaire-card-table',
	extends: CardTable,

	props: {
		patient: {
			type: Object,
			required: true
		},
		appointments: {
			type: Array
		}
	},

	data() {
		return {
			edit: false,
			expand: []
		}
	},

	computed: {
		appointmentType() {
			var type = {}
			this.appointments.forEach((appointment) => {
				let t = appointment.type.split(':')[1] + ':' + appointment.provider
				if (! type[t])
					type[t] = {
						id: t,
						event: []
					}
				type[t].event.push(appointment)
			})
			return Object.keys(type).map((t) => {
				type[t].event.sort((a, b) => (b.time - a.time))
				type[t].active = type[t].event.filter((a) => (a.time + 86400000 > Date.now()))
				if (type[t].active.length > 0)
					type[t].last = type[t].active[type[t].active.length - 1]
				return type[t]
			})
		}
	},

	components: {
		AppointmentSummary
	}
}
</script>

<style lang='scss'>
@import "@/module/app/theme/color.scss";

.vital-icon {
	width: 40px;
	height: 40px;
	float: left;
}
.appointment-provider {
    padding-left: 12px;
    display: inline;
    align-items: center;
    color: $grey-700;
    font-weight: normal;
	&::before {
		content: "\A";
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: $black-color;
		display: inline-block;
		margin-right: 12px;
		margin-bottom: 3px;
	}
}
</style>
